import { Container, Button,Form, Alert,Table} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,StyckeCompact} from "./ContentStyles";
import React, { useState ,useEffect} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import useBackend, {CallAPI, Loading, SpinnerX} from '../services/useBackend';
import {Branding, DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, AddTimezoneOffset} from '../services/misc';

var typingTimeout = null;
var shopGUID = null;

export default function ShopEdit() {
    const {ShopGUID} = useParams();
    shopGUID = ShopGUID;

    const {loading, data, Refresh} =  useBackend('/api/admin/shop/'+ShopGUID);
	const {loading:loadingLockState, data:dataLockState, Refresh:RefreshLockState} =  useBackend('/api/admin/shop/'+ShopGUID+'/GetState');

	const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);

	function handleChange(event){
		clearTimeout(typingTimeout);
		typingTimeout = setTimeout(handleSave, 475);
	}

	async function RenewEntryCodeClicked(event){	
		event.preventDefault();
		await CallAPI('/api/admin/shop/'+shopGUID+'/renewentrycode',"PUT");	
		Refresh();
	}

	async function ReleaseLockAsync(event){	
		event.preventDefault();
		await CallAPI('/api/admin/shop/'+shopGUID+'/ReleaseLock',"PUT");	
		Refresh();
	}

	async function handleSave(){
		const ProductForm = document.getElementById('ProductForm');
		const formData = new FormData(ProductForm);
	
		const formDataObj = Object.fromEntries(formData.entries());
	
		formDataObj.Swish       = formData.has('Swish') ? true : false;
		formDataObj.CustomizedPayment        = formData.has('CustomizedPayment') ? true : false;
		formDataObj.TestPayment = formData.has('TestPayment') ? true : false;

		formDataObj.OpeningHoursUTCStart = ConcatLocalDateAndTime2ISO("1900-01-01",formDataObj.OpeningHoursUTCStart);
		formDataObj.OpeningHoursUTCEnd   = ConcatLocalDateAndTime2ISO("1900-01-01",formDataObj.OpeningHoursUTCEnd);

		await CallAPI('/api/admin/shop/'+shopGUID,"PATCH",JSON.stringify(formDataObj));
		Refresh();		
	}

	const handleClaimSubmit = async (e) =>{
		e.preventDefault();
		setResultText("");
		setResultVisible(false);
		const ShopForm = document.getElementById('AddShopForm');
		const formData = new FormData(ShopForm);
		const formDataObj = Object.fromEntries(formData.entries());
		formDataObj.Description = ".";

		let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/admin/shop/'+shopGUID+'/ClaimLock', 'PUT', JSON.stringify(formDataObj));

		setResultVariant(resultVariant);   
		setResultText(resultText);
		setResultVisible(resultVisible);

		setResultVisible(true);

		Refresh();
		RefreshLockState();
	}  

	function createDocument(event){
		const docType = event.currentTarget.getAttribute("docType");
		window.open('https://www.nookshop.se/api/shop/'+shopGUID+'/docs/'+docType, '_blank', 'noreferrer');
	}  

    if (!loading) {
        return (
            <ContentWrapper>
				
                <Container>
                    <Sida>
						<Rubrik>Butiksinformation</Rubrik>

						<Form onSubmit={handleSave} id="ProductForm">

							<Form.Group className="mb-3" >
                                <Form.Label>Namn</Form.Label>
								<Form.Control type="text" onChange={handleChange} name="Name" placeholder="ButikID"  defaultValue={data.Shop.Name} />
							</Form.Group>

							<Form.Group className="mb-3" >
                                <Form.Label>Beskrivning</Form.Label>
								<Form.Control type="text" onChange={handleChange} name="Description" placeholder="Produktbeskrivning" defaultValue={data.Shop.Description} />
							</Form.Group>  

							<Form.Group className="mb-3" >
                                <Form.Label>Max tillåtna ofullständiga köp</Form.Label>
								<Form.Control type="text" onChange={handleChange} name="MaxAllowedUncompletedSessions" placeholder="MaxAllowedUncompletedSessions" defaultValue={data.Shop.MaxAllowedUncompletedSessions} />
							</Form.Group>  

							<Form.Group className="mb-3" >
                                <Form.Label>Minsta ålder för att använda butiken</Form.Label>
								<Form.Control type="text" onChange={handleChange} name="MinCustomerAge" placeholder="MinCustomerAge" defaultValue={data.Shop.MinCustomerAge} />
							</Form.Group>

							<Form.Group className="mb-3" >
                                <Form.Label>Öppettider</Form.Label>
								<div className="d-flex">
									<Form.Control type="time"  onChange={handleChange} name="OpeningHoursUTCStart" defaultValue={SplitoutLocalTimeFromISO(data.Shop.OpeningHoursUTCStart)} size='sm' step="60"/>&nbsp;till&nbsp;
									<Form.Control type="time"  onChange={handleChange} name="OpeningHoursUTCEnd"   defaultValue={SplitoutLocalTimeFromISO(data.Shop.OpeningHoursUTCEnd)}   size='sm' step="60"/>
								</div>
							</Form.Group>
													
							<Form.Group className="mb-3">
								<Form.Label>EntryCode</Form.Label>
								<div className="d-flex">
								{data.Shop.EntryCode!=null ?
									(<Form.Control type="text"  value={data.Shop.EntryCode.Code} disabled />) :(<Form.Control type="text"  disabled />)
								}&nbsp;
								{/* <Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="submit" onClick={RenewEntryCodeClicked}>Förnya</Button> */}
								</div>
							</Form.Group>

							<Rubrik>Betalalternativ</Rubrik>

							<Form.Group className="mb-3" >
								<Form.Check 
									type="switch"
									name="Swish"
									id="Swish"
									label="Swish"
									disabled={!data.Instance.ConfiguredPayments.Swish}
									defaultChecked={data.Shop.Swish}
									value={data.Shop.Swish}
									onChange={handleChange}
								/>
							</Form.Group>

							<Form.Group className="mb-3" >
								<Form.Check 
									type="switch"
									name="TestPayment"
									id="TestPayment"
									label="Testbetalning"
									disabled={!data.Instance.ConfiguredPayments.TestPayment}
									defaultChecked={data.Shop.TestPayment}
									onChange={handleChange}
								/>
							</Form.Group>																				                          
							
							<Form.Group className="mb-3" >
								<Form.Check 
									type="switch"
									name="CustomizedPayment"
									id="CustomizedPayment"
									label={'Kundanpassad betalningslösning (' + data.Instance.ConfiguredPayments.CustomizedPaymentName + ')'}
									disabled={!data.Instance.ConfiguredPayments.CustomizedPayment}
									defaultChecked={data.Shop.CustomizedPayment}
									onChange={handleChange}
								/>
							</Form.Group>          

							<Rubrik>Skapa skyltar och dokument</Rubrik>

							<Button className="QmeButton_" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" onClick={createDocument} docType="display">Skylt till kylskåp</Button> &nbsp;&nbsp;
							<Button className="QmeButton_" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" onClick={createDocument} docType="sticker">Klistermärke till dörr</Button> &nbsp;&nbsp;
							<Button className="QmeButton_" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" onClick={createDocument} docType="pricelist">Prislista</Button> &nbsp;&nbsp;
							<Button className="QmeButton_" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" onClick={createDocument} docType="instruction">Instruktion</Button> &nbsp;&nbsp;

							{!data.Instance.ConfiguredPayments.Swish && 
								<Form.Group className="mb-3" >
									<Alert variant="danger">Innan Swish kan aktiveras behöver ett certifikat för Swish-handel installeras. Kontakta din bank för mer information. </Alert>
								</Form.Group> 							
							}
						</Form> 		



						{(!loadingLockState) && 
							(dataLockState.LockState != null && data.Shop.Lock.LockType != null) ?
							<>
								<Rubrik>Kopplat lås</Rubrik>
								<StyckeCompact>
								<table>
									{(data.Shop.Lock.LockType == 'IOTCore') && <>
										<tr><td>Låstyp:</td><td>{data.Shop.Lock.LockType}</td></tr>
										<tr><td>LåsID:</td><td>{data.Shop.Lock.SerialNumber}</td></tr>
										<tr><td>Uppkoppling:</td><td>{dataLockState.LockState.online ? <>Online</> : <>Offline</>}</td></tr>
										<tr><td>Signalstyrka (dBm):   </td><td>{dataLockState.LockState.RSSI}</td></tr>
										<tr><td>Dörr:</td><td>{dataLockState.LockState.lockState}</td></tr>
										<tr><td>Temperatur:</td><td>{dataLockState.LockState.temperature}</td></tr>
										<tr><td>Senaste kontakt:</td><td>{DateTimeToLocal(dataLockState.LockState.lastonline)}</td></tr>
									</>}
								</table>

								<Button style={{backgroundColor:Branding().ButtonColor}} className="QmeButton" onClick={ReleaseLockAsync}>Koppla från Lås</Button>
								</StyckeCompact>									
							</> : <>
							<Alert variant="warning">
								<Form onSubmit={handleClaimSubmit} id="AddShopForm">
									<Form.Group className="mb-3" >
											<Rubrik>Anslut lås</Rubrik>
											<Form.Control type="text" name ="ChipID" placeholder="ID på låsmodul/kylskåp" />                            
									</Form.Group>      
		
									<Form.Group className="mb-3"  hidden={!loading}>
										<SpinnerX  />
									</Form.Group>                                                                           
								</Form>     
								<Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} onClick={handleClaimSubmit}>Anslut Lås</Button>
							
							</Alert>							
							</>	
						}	

						<Form.Group className="mb-3"  hidden={!loading}>
							<SpinnerX  />
						</Form.Group>                                      
							
						<Form.Group className="mb-3"  hidden={!resultVisible}>
							<Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert> 
						</Form.Group> 																

                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}